module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('vue-headful', {
    attrs: {
      "title": 'SGP - Registro de Ocorrências'
    }
  }), _vm._v(" "), _c('div', [_c('section', {
    staticClass: "content-header"
  }, [_vm._m(0), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": [{
        text: 'Inicial',
        href: '/'
      }, {
        text: 'Cadastro',
        href: '#'
      }, {
        text: 'Ocorrência',
        active: true
      }]
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "id": "listaOcorrencias"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('edita-ocorrencias', {
    attrs: {
      "idProcesso": _vm.id,
      "botaoVoltar": _vm.botaoVoltar
    },
    on: {
      "acaoOcorrencia": function($event) {
        _vm.ocorrenciaSelecionada = $event
      },
      "acaoProcessamento": function($event) {
        _vm.loading.tela = true
      },
      "acaoAguardando": function($event) {
        _vm.loading.tela = false
      },
      "acaoCancelar": function($event) {
        return _vm.$router.go(-1)
      },
      "acaoOk": function($event) {
        _vm.loading.tela = false
      }
    }
  })], 1)])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('span', [_vm._v("Ocorrências")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f10bdfe8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cadastro/ocorrencias/ListaOcorrencias.vue
// module id = 2100
// module chunks = 1